var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "t-player__controller" }, [
    _c("div", { staticClass: "t-player__controls" }, [
      _c(
        "div",
        { staticClass: "t-player__controls-main" },
        [
          _c(
            "t-button",
            {
              staticClass: "t-player__control",
              attrs: { disabled: _vm.hidePrev, variant: "action" },
              on: {
                click: function($event) {
                  return _vm.$emit("backward")
                }
              }
            },
            [_c("i", { staticClass: "fas fa-step-backward t-fs--body" })]
          ),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "fade", mode: "out-in" } },
            [
              _vm.isPaused || _vm.isEnded
                ? _c(
                    "t-button",
                    {
                      key: "play",
                      staticClass: "t-player__control",
                      attrs: { variant: "action" },
                      on: {
                        click: function($event) {
                          return _vm.play()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-play t-fs--body" })]
                  )
                : _c(
                    "t-button",
                    {
                      key: "pause",
                      staticClass: "t-player__control",
                      attrs: { variant: "action" },
                      on: {
                        click: function($event) {
                          return _vm.pause()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-pause t-fs--body" })]
                  )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "t-button",
            {
              staticClass: "t-player__control",
              attrs: { disabled: _vm.hideNext, variant: "action" },
              on: {
                click: function($event) {
                  return _vm.$emit("forward")
                }
              }
            },
            [_c("i", { staticClass: "fas fa-step-forward t-fs--body" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "t-player__control" }, [
            _vm._v("Slide " + _vm._s(_vm.slide))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "t-player__controls-aside" },
        [
          _c(
            "div",
            { staticClass: "t-player__subtitle-control t-mar--r-xs" },
            [
              !_vm.$isEmpty(_vm.subtitleTracks)
                ? _c(
                    "t-button",
                    {
                      staticClass: "t-player__control t-mar--r-no",
                      attrs: { variant: "action" },
                      on: {
                        click: function($event) {
                          _vm.subtitleTracks.length > 1 && !_vm.$isMobile
                            ? _vm.showSubtitleTrackOptions()
                            : _vm.toggleCaption()
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fa-closed-captioning fa-fw t-fs--h4",
                        class: [
                          { far: !_vm.subtitleLanguage },
                          { fas: _vm.subtitleLanguage }
                        ]
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
                _vm.showPopover
                  ? _c(
                      "div",
                      {
                        key: "popover",
                        staticClass:
                          "t-popover t-popover--top t-popover--center"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "t-popover__list" },
                          [
                            _vm._l(_vm.subtitleTracks, function(s) {
                              return _c(
                                "div",
                                {
                                  key: s.id,
                                  staticClass:
                                    "t-popover__item t-cursor--pointer",
                                  class: {
                                    "t-popover__item--active":
                                      _vm.subtitleLanguage == s.lang
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.setSubtitle(s)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(s.name) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                key: "off",
                                staticClass:
                                  "t-popover__item t-cursor--pointer",
                                class: {
                                  "t-popover__item--active": !_vm.subtitleLanguage
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.setSubtitle("")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("generic.text.off")) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          2
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "t-button",
            {
              staticClass: "t-player__control",
              attrs: { variant: "action" },
              on: { click: _vm.exitSlideMode }
            },
            [_c("i", { staticClass: "fas fa-video t-fs--body" })]
          ),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "fade", mode: "out-in" } },
            [
              !_vm.isFullScreen
                ? _c(
                    "t-button",
                    {
                      staticClass: "t-player__control",
                      attrs: { variant: "action" },
                      on: {
                        click: function($event) {
                          return _vm.enterFullScreen()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-expand" })]
                  )
                : _c(
                    "t-button",
                    {
                      staticClass: "t-player__control",
                      attrs: { variant: "action" },
                      on: {
                        click: function($event) {
                          return _vm.exitFullScreen()
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/lib/assets/images/icons/fullscreen_exit-white.svg"),
                          height: "24px"
                        }
                      })
                    ]
                  )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }